/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBadgeLeft = createReactComponent("outline", "arrow-badge-left", "IconArrowBadgeLeft", [["path", { "d": "M11 17h6l-4 -5l4 -5h-6l-4 5z", "key": "svg-0" }]]);

export { IconArrowBadgeLeft as default };
//# sourceMappingURL=IconArrowBadgeLeft.mjs.map
